module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.4 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/icon.html"
    }
  }, [_vm._v("Icon")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] No more built-in `icon-big` classname, use `is-msg` instead. #988 @greedying")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/tabbar.html"
    }
  }, [_vm._v("Tabbar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix this.$slots undefined #1000 @asingingfish")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/toast.html"
    }
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support position setting. #973 @ LaiXuechao")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-icon.html"
    }
  }, [_vm._v("XIcon")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new component")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03609a4e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-03609a4e"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.4-83.vue
// module id = 2005
// module chunks = 344